import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { CircleMinus, CirclePlus, Info } from 'lucide-react';
import { Tooltip } from 'primereact/tooltip';

import { CHARGEBACK_KEY, PROJECT_KEY } from '../constant/constant';

const TableDetails = ({ dimensionList, action, widgetFormik }) => {
  const headingKeys = [],
    tableLen = widgetFormik.values?.table_configuration.length;
  widgetFormik.values?.table_configuration.forEach(record => {
    if (!headingKeys.includes(record.measureName)) {
      headingKeys.push(record.measureName);
    }
  });
  const handleRemove = index => {
    widgetFormik.values.table_configuration.splice(index, 1);
    widgetFormik.setFieldValue(
      'table_configuration',
      widgetFormik.values.table_configuration
    );
  };
  const handleInsert = index => {
    const firstHalfArr = widgetFormik.values.table_configuration.slice(
      0,
      index + 1
    );
    const secondHalfArr = widgetFormik.values.table_configuration.slice(
      index + 1,
      widgetFormik.values.table_configuration.length
    );
    const finalArr = [
      ...firstHalfArr,
      { measureName: '', alice: '' },
      ...secondHalfArr,
    ];
    widgetFormik.setFieldValue('table_configuration', finalArr);
  };

  return widgetFormik.values.table_configuration.map((record, index) => {
    return (
      <>
        <div className="grid grid-nogutter col-12 md:col-4 gap-2 align-items-baseline">
          <div className="col-10 p-0">
            <span className="p-float-label">
              <Dropdown
                showClear
                filter
                key={widgetFormik.values.table_configuration[index].measureName}
                id="chartType"
                name={`table_configuration.${index}.label`}
                options={dimensionList.filter(({ name }) => {
                  return (
                    name ===
                      widgetFormik.values.table_configuration[index]
                        .measureName || !headingKeys.includes(name)
                  );
                })}
                disabled={action === 'view' ? true : false}
                value={
                  dimensionList.find(
                    item =>
                      item.name ==
                      widgetFormik.values.table_configuration[index].measureName
                  )?.value
                }
                optionLabel="value"
                optionValue="value"
                className="w-full"
                onChange={async event => {
                  const selectedLabel = event.value;

                  const fullObject = dimensionList.find(
                    item => item.value === selectedLabel
                  );

                  const updatedTableConfig = [
                    ...widgetFormik.values.table_configuration,
                  ];

                  updatedTableConfig[index] = {
                    ...updatedTableConfig[index],
                    measureName: fullObject?.name || '',
                    alice: fullObject?.shortTitle || '',
                  };

                  // Handle custom_properties safely
                  let updatedCustomProps = {
                    ...(widgetFormik.values?.custom_properties || {}),
                  };

                  if (
                    fullObject?.firstLetter === CHARGEBACK_KEY &&
                    fullObject?.key?.includes(PROJECT_KEY)
                  ) {
                    updatedCustomProps.reportTableSecondaryKey = `${CHARGEBACK_KEY}.project_id`;
                  }

                  const dimensionMeta = dimensionList.find(
                    item => item.name === fullObject?.name
                  );

                  if (
                    dimensionMeta?.meta?.addField &&
                    !updatedCustomProps?.additional_dimensions?.includes(
                      dimensionMeta.meta.addField
                    )
                  ) {
                    updatedCustomProps.additional_dimensions = [
                      ...(updatedCustomProps.additional_dimensions || []),
                      dimensionMeta.meta.addField,
                    ];
                  }

                  widgetFormik.setFieldValue(
                    'custom_properties',
                    updatedCustomProps
                  );
                  await widgetFormik.setFieldValue(
                    'table_configuration',
                    updatedTableConfig
                  );

                  // Order by fix
                  if (!widgetFormik.values?.order_by?.orderField) {
                    widgetFormik.setFieldValue('order_by', {
                      ...widgetFormik.values.order_by,
                      orderField: fullObject?.name || '',
                    });
                  }
                }}
              />
              <label htmlFor="chartType">
                Field <span className="text-red-400">*</span>
              </label>
            </span>
          </div>
          <div className="col-1 p-0">
            <Info
              className="text-primary text-sm w-1rem h-1rem report-field-icon"
              data-pr-tooltip=" Select the main field for the Report"
              data-pr-position="bottom"
            />
            <Tooltip
              target=".report-field-icon"
              pt={{
                root: { className: 'p-2' },
                text: { className: 'text-xs' },
              }}
            />
          </div>
        </div>
        <div className="grid grid-nogutter col-12 md:col-4 gap-2 align-items-baseline">
          <div className="col-10 p-0">
            <span className="p-float-label">
              <InputText
                className="w-full"
                value={widgetFormik.values.table_configuration[index].alice}
                onChange={event => {
                  widgetFormik.values.table_configuration[index].alice =
                    event.target.value;
                  widgetFormik.setFieldValue(
                    'table_configuration',
                    widgetFormik.values.table_configuration
                  );
                }}
                disabled={action === 'view' ? true : false}
              />
              <label htmlFor="chartType">
                Field Alias<span className="text-red-400">*</span>
              </label>
            </span>
          </div>
          <div className="col-1 p-0">
            <Info
              className="text-primary text-sm w-1rem h-1rem alias-field-icon"
              data-pr-tooltip="Set a display label for this field"
              data-pr-position="bottom"
            />
            <Tooltip
              target=".alias-field-icon"
              pt={{
                root: { className: 'p-2' },
                text: { className: 'text-xs' },
              }}
            />
          </div>
        </div>
        <div className="col-12 md:col-1 md:flex md:justify-content-center md:align-items-center md:gap-2">
          {action !== 'view' && (
            <>
              <CirclePlus
                className="text-primary text-sm w-1rem h-1rem"
                onClick={() => handleInsert(index)}
              />
              {tableLen > 1 && (
                <CircleMinus
                  className="text-primary text-sm w-1rem h-1rem"
                  fontSize="large"
                  onClick={() => handleRemove(index)}
                />
              )}
            </>
          )}
        </div>
      </>
    );
  });
};

export default TableDetails;
